import { Box as MuiBox, type BoxProps as MuiBoxProps } from '@mui/material';

import type {
  BaseComponentProps,
  FlexAlignmentProps,
  SpacingProps,
} from '../../utils/types';

export interface ColumnsProps
  extends BaseComponentProps,
    FlexAlignmentProps,
    SpacingProps,
    Pick<MuiBoxProps, 'color' | 'sx' | 'children' | 'flex'> {
  spacing?: number;
  fullWidth?: boolean;
}

export const Columns = ({
  children,
  spacing = 1,
  fullWidth = false,
  color,
  justifyContent = 'flex-start',
  sx,
  ...otherProps
}: ColumnsProps) => (
  <MuiBox
    gap={spacing}
    display="flex"
    flexDirection="row"
    sx={{
      color: color ? `${color}.main` : undefined,
      backgroundColor: color ? `${color}.background` : undefined,
      '& > *': fullWidth ? { flex: 1 } : undefined,
      ...sx,
    }}
    justifyContent={justifyContent}
    {...otherProps}
  >
    {children}
  </MuiBox>
);
